import HeaderMenuToggle from "./_HeaderMenuToggle";
import SearchMenuToggle from "./_SearchMenuToggle";
import HeaderLangToggle from "./_HeaderLangToggle";

const Header = () => {

  const headerMenuToggle = new HeaderMenuToggle();
  const searchMenuToggle = new SearchMenuToggle();
  const headerLangToggle = new HeaderLangToggle();

  //検索メニュー内の閉じるボタン
  const searchCloseEl = document.querySelector('.l-header__search-close');
  searchCloseEl.addEventListener('click', () => {
    searchMenuToggle.close();
  });

  // 検索トグルボタン
  document.getElementById('searchMenuToggle').addEventListener('click', () => {
    // ヘッダーメニューが開いていたら閉じる
    if (headerMenuToggle.open) {
      headerMenuToggle.close();
    }
    //searchMenuToggle.toggle(!searchMenuToggle.open);
  });

  //.l-header__search-menuをクリックで閉じる
  const searchMenuEl = document.querySelector('.l-header__search-menu');
  searchMenuEl.addEventListener('click', () => {
    searchMenuToggle.close();
  });

  //stopPropagation
  const searchMenuInnerEl = document.querySelector('.l-header__search-menu-inner');
  searchMenuInnerEl.addEventListener('click', (e) => {
    e.stopPropagation();
  });
  const langtoggleEl = document.getElementById('headerLangToggle');
  langtoggleEl.addEventListener('click', (e) => {
    e.stopPropagation();
  });

  // ヘッダーメニュートグルボタン
  document.getElementById('headerMenuToggle').addEventListener('click', () => {
    // 検索メニューが開いていたら閉じる
    if (searchMenuToggle.open) {
      searchMenuToggle.close();
    }
    // 言語メニューが開いていたら閉じる
    if (headerLangToggle.open) {
      headerLangToggle.close();
    }
    //headerMenuToggle.toggle(!headerMenuToggle.open);
  });

  //ヘッダーのsublistが表示中の場合、l-headerにクラス付与
  const sublistEls = document.querySelectorAll('.l-header__nav-item--dropdown');
  sublistEls.forEach(sublistEl => {
    sublistEl.addEventListener('mouseenter', () => {
      document.querySelector('.l-header').classList.add('is-sublist-open');
      //言語メニューが開いていたら閉じる
      if (headerLangToggle.open) {
        headerLangToggle.close();
      }
    });
    sublistEl.addEventListener('mouseleave', () => {
      document.querySelector('.l-header').classList.remove('is-sublist-open');
    });
  });

  //document.bodyクリックで、言語メニューが開いていたら閉じる
  document.body.addEventListener('click', () => {
    if (headerLangToggle.open) {
      headerLangToggle.close();
    }
  });
}
  
export default Header;